"use client";

import IndustryInsightsCardWithDesc from "@molecules/IndustryInsightsCard/IndustryInsightsCardWithDesc";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

export default function IndustryInsightsWithDesc({ IndustryInsights }) {
  return (
    <Swiper
      modules={[Pagination, Autoplay]}
      spaceBetween={50}
      slidesPerView={1}
      autoplay={{
        delay: 6000,
      }}
      pagination={{ clickable: true }}
      className="Carousel__blueBullet Carousel__hAuto"
      breakpoints={{
        1199: {
          slidesPerView: 1,
        },
        1200: {
          slidesPerView: 3,
        },
      }}
    >
      {IndustryInsights?.filter((x) => x?.enabled)?.map(
        (item: any, i: number) => (
          <SwiperSlide key={i}>
            <IndustryInsightsCardWithDesc key={i} {...item} />
          </SwiperSlide>
        )
      )}
    </Swiper>
  );
}
